import React from 'react';

interface OutlineButtonProps {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  size?: 'small' | 'medium';
}

const OutlineButton: React.FC<OutlineButtonProps> = ({
  children,
  onClick,
  disabled = false,
  type = 'button',
  size = 'medium',
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.(e);
  };

  const buttonClass =
    size === 'small' ? 'c-btn-outline -small' : 'c-btn-outline';

  return (
    <div className={buttonClass}>
      <button
        onClick={onClick ? handleClick : undefined}
        disabled={disabled}
        type={type}
      >
        {children}
      </button>
    </div>
  );
};

export default OutlineButton;
